import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Apply saved theme (default: dark)
const savedTheme = localStorage.getItem("arrivo_theme") || "dark";
document.documentElement.classList.add(savedTheme);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
